import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';

const EmailConfirmationPendingPage = () => {
  const { authData } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authData?.isEmailConfirmed) {
      toast.success('Email already confirmed! Redirecting to login...');
      navigate('/login');
    }
  }, [authData, navigate]);

  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>Email Confirmation Pending</h1>
      <p>
        You need to confirm your email address before accessing the platform. Please check your
        inbox for the confirmation email.
      </p>
      <p>
        If you haven't received the email, <Link to="/resend-confirmation">click here</Link> to resend it.
      </p>
    </div>
  );
};

export default EmailConfirmationPendingPage;
